








































import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
// eslint-disable-next-line import/no-named-as-default
import Swiper from 'swiper'
import ComponentCategoryItem from '~/components/catalog/category/category-item.vue'
import ComponentButtonIcon from '~/components/form/button-icon.vue'
import { ICatalogCategoryItem } from '~/assets/interfaces/catalog'
import MixinGeneral from '~/assets/mixins/general'
import 'swiper/swiper.scss'

@Component({
  components: {
    ComponentCategoryItem,
    ComponentButtonIcon,
  },
})
export default class ComponentCatalogCategory extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] })
  readonly categories!: ICatalogCategoryItem[]

  private slidesPerView: number = 6

  private swiper!: Swiper

  private isBeginning = false
  private isEnd = false
  private activeIndex = 0

  private icons = {
    mdiChevronRight,
    mdiChevronLeft,
  }

  @Watch('slidesPerView')
  private slidesPerViewHandler() {
    this.initSlider()
  }

  private initSlider() {
    if (this.swiper) {
      this.swiper.destroy()
    }

    const categoriesContainer: HTMLElement = this.$refs
      .categoriesContainer as HTMLElement

    if (categoriesContainer) {
      this.swiper = new Swiper(categoriesContainer, {
        direction: 'horizontal',
        slidesPerView: 6,
        spaceBetween: 15,
        watchSlidesVisibility: false,
      })
      this.swiper.slideTo(0)
      this.isBeginning = this.swiper.isBeginning
      this.isEnd = this.swiper.isEnd
      this.activeIndex = this.swiper.activeIndex
    }
  }

  private slidePrev() {
    if (!this.swiper.isBeginning) {
      this.swiper.slidePrev()
    }
    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
    this.activeIndex = this.swiper.activeIndex
  }

  private slideNext() {
    if (!this.swiper.isEnd) {
      this.swiper.slideNext()
    }
    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
    this.activeIndex = this.swiper.activeIndex
  }

  private get showNavigation() {
    return this.categories.length - 1 >= this.slidesPerView
  }

  private destroyed() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  private mounted() {
    this.initSlider()
  }
}
